(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    function attachHoverCycle(gallery) {
      if (gallery._galleryHoverReady) return;
      gallery._galleryHoverReady = true;

      var timer = null;

      gallery.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse') return;
        var slideshow = gallery.querySelector('[ref="slideshow"]');
        if (!slideshow || typeof slideshow.next !== 'function') return;

        clearInterval(timer);
        slideshow.next(undefined, { animate: false });
        timer = setInterval(function () {
          slideshow.next(undefined, { animate: false });
        }, 1500);
      });

      gallery.addEventListener('pointerleave', function (e) {
        if (e.pointerType !== 'mouse') return;
        clearInterval(timer);
        timer = null;
        var slideshow = gallery.querySelector('[ref="slideshow"]');
        if (slideshow && typeof slideshow.select === 'function') {
          slideshow.select(0, undefined, { animate: false });
        }
      });
    }

    function initAll() {
      document.querySelectorAll('.card-gallery').forEach(function (el) {
        attachHoverCycle(el);
      });
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', initAll);
    }

    document.addEventListener('page:loaded', initAll);
    document.addEventListener('shopify:section:load', initAll);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.classList && node.classList.contains('card-gallery')) {
            attachHoverCycle(node);
          }
          if (node.querySelectorAll) {
            node.querySelectorAll('.card-gallery').forEach(attachHoverCycle);
          }
        });
      });
    });

    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        observer.observe(document.body, { childList: true, subtree: true });
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
